import { useState } from 'react';

import { useNotifications } from 'core/hooks/useNotifications';
import { client, useErrorNotifications } from 'core/http';
import { Service } from 'core/types/service';

export default function useServicesImport() {
  const showErrorNotification = useErrorNotifications();
  const showNotification = useNotifications({ variant: 'success' });
  const [loading, setLoading] = useState(false);

  const importServices = (file: File) => {
    setLoading(true);

    const formData = new FormData();
    formData.append('services', file);

    return client()
      .post<Array<Service & { pivot: { price: number } }>>(
        `services/import`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      .then((response) => {
        showNotification(
          `Päivitettiin ${response.data.length} työtä & tarviketta. Päivitä sivu nähdäksesi muutokset heti.`
        );
        return response.data;
      })
      .catch((error) => {
        showErrorNotification(error);
        throw error;
      })
      .finally(() => setLoading(false));
  };

  return { importServices, loading };
}
